module.exports = __webpack_public_path__ + "static/distribuidora-125568c6b91ba5c7ab5c36bce48e30f4.jpg";